import React from 'react';
import { ICellRendererParams } from '@trackman/baseball-shared-components';
import { IReviewDataRow } from 'interfaces/review/IReviewDataRow';
import { TimeCell } from '../CellComponents/TimeCell/TimeCell';

export const timeCellRenderer = (data: ICellRendererParams<any, IReviewDataRow>) => {
  return (
    <TimeCell
      selectedValue={data.value ? new Date(data.value) : null}
      onSelectionChanged={(newValue: any) => data.row.updateData(newValue, data.columnKey, data.row.id)}
      isAddedManually={data.row.isAddedManually}
    />
  );
};
